import { parseColorToRgb } from './colorUtils';

/**
 * Calcula si un color de fondo necesita texto negro o blanco
 * basándose en la luminancia percibida (WCAG).
 * @param {string} color - Color en formato #rrggbb, #rgb, rgb(...) o rgba(...)
 * @returns {string} '#000000' o '#ffffff'
 */
export const getContrastColor = (color) => {
  const rgb = parseColorToRgb(color);
  if (!rgb) return '#ffffff';
  const [r, g, b] = rgb;
  // Luminancia percibida (fórmula WCAG)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#000000' : '#ffffff';
};
